import { useLazyQuery } from '@apollo/client';
import { EuiFormLabel, EuiComboBox, EuiComboBoxOptionOption } from '@elastic/eui';
import { COATING_COLORS } from 'apollo-client/queries/getAvailableCoatingColors';
import { useIntl } from 'react-intl';
import { Query, QueryGetAvailableCoatingColorsArgs } from 'generated/graphql';
import { coatingColors } from 'cache';
import { useLocalCache } from 'hooks/useLocalCache';

import * as S from './FiltersSidebar.styles';

export const CoatingColorsFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const localFilters = useLocalCache();
  const [onGetAvailableCoatingColors, { loading, data }] = useLazyQuery<Query, QueryGetAvailableCoatingColorsArgs>(
    COATING_COLORS
  );

  return (
    <S.SidebarFilterWrapper>
      <EuiFormLabel>{formatMessage({ id: 'filters.coatingColors.label' })}</EuiFormLabel>
      <EuiComboBox
        async
        isLoading={loading}
        placeholder={formatMessage({ id: 'filters.coatingColors.placeholder' })}
        options={data?.getAvailableCoatingColors?.map((x: string) => ({ label: x, value: x })) ?? []}
        selectedOptions={localFilters?.data?.coatingColors?.map((x: string) => ({ label: x, value: x }))}
        onSearchChange={(e: string): void => {
          onGetAvailableCoatingColors({ variables: { inputCoatingColor: e } });
        }}
        onClick={(): void => {
          onGetAvailableCoatingColors({ variables: { inputCoatingColor: '' } });
        }}
        onChange={(x: EuiComboBoxOptionOption<string>[]): string[] | undefined =>
          coatingColors(x?.map(({ value }) => value) as string[])
        }
      />
    </S.SidebarFilterWrapper>
  );
};
